import styled from 'styled-components';

export const VoucherCheckoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding-bottom: 0.5rem;
`;

export const VoucherRecipientInfo = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  font-style: italic;

  div {
    display: flex;
    flex-direction: column;
  }
`;

export const GreetingMessage = styled.div`
  font-style: italic;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
